'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _drawer = require('drawer');

var _drawer2 = _interopRequireDefault(_drawer);

var _EventHandler = require('../utils/EventHandler');

var _EventHandler2 = _interopRequireDefault(_EventHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DynamicDrawer = function () {
  function DynamicDrawer(section) {
    var _this = this;

    (0, _classCallCheck3.default)(this, DynamicDrawer);

    this.el = section.el;
    this.ev = new _EventHandler2.default();
    this.drawerEl = this.el.querySelector('.drawer-wrap');

    if (this.drawerEl) {
      this.drawer = new _drawer2.default(this.drawerEl);

      document.querySelectorAll('a[href="#' + this.drawerEl.id + '"]').forEach(function (link) {
        _this.ev.register(link, 'click', function (e) {
          e.preventDefault();
          _this.drawer.open();
        });
      });
    }
  }

  (0, _createClass3.default)(DynamicDrawer, [{
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      if (this.drawer) {
        this.drawer.unload();
      }
      this.ev.unregisterAll();
    }
  }]);
  return DynamicDrawer;
}();

exports.default = DynamicDrawer;